import { CheckCircle2 } from "lucide-react";
import { accreditations } from "../data/media";

export const AccreditationBadges = ({ testId = "accreditations" }) => (
  <ul data-testid={testId} className="mt-6 grid gap-x-8 gap-y-4 sm:grid-cols-2">
    {accreditations.map((label, i) => (
      <li
        key={label}
        data-testid={`${testId}-item-${i + 1}`}
        className="flex items-center gap-3 text-sm text-[#f2ede3]"
      >
        <CheckCircle2 size={16} className="shrink-0 text-[#c9a24b]" />
        {label}
      </li>
    ))}
  </ul>
);
